import {jwtDecode} from 'jwt-decode';

export const toFarsiNumber = (number) => {
    const farsiDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return number.toString().split('').map(x => farsiDigits[x]).join('');
};

export const generateDiscountCode =(length) => {
    const chars = 'qwertyuiopasdfghjklzxcvbnm0123456789';

    let code = '';
    for(let i = 0; i < length; i++) {
        code += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return code;
}

export const getRolesFromToken = (token) => {
    try {
        const decodedToken = jwtDecode(token);
        // Assuming roles are stored under 'realm_access' -> 'roles'
        return decodedToken.realm_access.roles;
    } catch (error) {
        console.error('Error decoding token:', error);
        return [];
    }
};

export const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))